import { c as _c } from "react/compiler-runtime";
import { EyeIcon } from '@systemeio/ui/icons';
import { BreadcrumbsData, PrimaryButton } from '@systemeio/ui';
import EditFunnelModal from 'modules/funnels/funnel/components/edit-funnel-modal';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React from 'react';
import BreadcrumbsDashboard from 'shared/components/breadcrumbs';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useDeviceMode } from '../context/device-mode-context';
interface FunnelHeaderProps {
  funnelId: FunnelId;
  selectedFunnelStep: FunnelStepInterface | null;
}
function FunnelHeader(t0) {
  const $ = _c(30);
  const {
    funnelId,
    selectedFunnelStep
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    resetSelectedMobileTab
  } = useDeviceMode();
  const {
    funnel
  } = useFunnel(funnelId);
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.funnel.breadcrumbs.funnel_list");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      caption: t1,
      href: "/funnels",
      isStatic: true
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = funnel?.name ?? "";
  let t4;
  if ($[4] !== resetSelectedMobileTab || $[5] !== t3) {
    t4 = {
      caption: t3,
      onClick: resetSelectedMobileTab
    };
    $[4] = resetSelectedMobileTab;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = selectedFunnelStep?.name ?? "";
  let t6;
  if ($[7] !== t5) {
    t6 = {
      caption: t5
    };
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t4 || $[11] !== t6) {
    t7 = [t2, t4, t6];
    $[9] = t2;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const breadcrumbsData = t7;
  const t8 = !funnel;
  let t9;
  if ($[13] !== breadcrumbsData || $[14] !== t8) {
    t9 = <BreadcrumbsDashboard data={breadcrumbsData} isFetching={t8} />;
    $[13] = breadcrumbsData;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = `/funnel/${funnelId}/show`;
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <EyeIcon className="fill-background-secondary" />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t) {
    t12 = t("dashboard.funnel.view_funnel");
    $[17] = t;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12) {
    t13 = <span className="hidden lg:flex">{t12}</span>;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t10 || $[22] !== t13) {
    t14 = <PrimaryButton as={LinkWithoutPrefetch} aria-disabled={false} href={t10} target="_blank" data-test-element="view-funnel-button">{t11}{t13}</PrimaryButton>;
    $[21] = t10;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <EditFunnelModal />;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t14) {
    t16 = <div className="flex gap-2 whitespace-nowrap lg:gap-5">{t14}{t15}</div>;
    $[25] = t14;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t16 || $[28] !== t9) {
    t17 = <div className="flex items-center justify-between gap-5">{t9}{t16}</div>;
    $[27] = t16;
    $[28] = t9;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
}
export default FunnelHeader;